export default class PaymentMethodDiscount {
    constructor(paymentMethod) {
        this.enableField = document.querySelector(
            `#woocommerce_vindi-pagamentos-${paymentMethod}_discount`
        );

        this.showTagField = document.querySelector(
            '#vindi-pagamentos-show_discount_text'
        );

        if (this.enableField) {
            this.discountTypeField = document.querySelector(
                `#woocommerce_vindi-pagamentos-${paymentMethod}_discount_type`
            ).closest('tr');
            this.discountValueField = document.querySelector(
                `#woocommerce_vindi-pagamentos-${paymentMethod}_discount_value`
            ).closest('tr');
        }

        if (this.showTagField) {
            this.textColorField = document.querySelector(
                '#vindi-pagamentos-text_color'
            ).closest('tr');
        }

        this.init();
    }

    init() {
        if (this.enableField) {
            this.toggleDiscountFields();
            this.enableField.addEventListener("change", () => {
                this.toggleDiscountFields();
            });
        }

        if (this.showTagField) {
            this.toggleColorFields();
            this.showTagField.addEventListener("change", () => {
                this.toggleColorFields();
            });
        }
    }

    toggleDiscountFields() {
        const isEnabled = this.enableField.checked;
        this.discountTypeField.style.display = isEnabled ? 'table-row' : 'none';
        this.discountValueField.style.display = isEnabled ? 'table-row' : 'none';
    }

    toggleColorFields() {
        const isEnabled = this.showTagField.checked;
        this.backgroundColorField.style.display = isEnabled ? 'table-row' : 'none';
        this.textColorField.style.display = isEnabled ? 'table-row' : 'none';
    }
}

jQuery(document).ready(function ($) {
    new PaymentMethodDiscount('bolepix');
    new PaymentMethodDiscount('pix');
});